import { combineReducers } from '@reduxjs/toolkit';

import authReducer from '../auth/authSlice';
import errorReducer from '../error/errorSlice';
import successReducer from '../success/successSlice';
import loadingReducer from '../loading/loadingSlice';
import ticketsReducer from '../tickets/ticketsSlice';
import languageReducer from '../language/languageSlice';
import userDataReducer from '../userData/userDataSlice';
import sideBarDataReducer from '../sideBar/sideBarSlice';
import tabsReducer from '../tabSelector/tabSelectorSlice';
import expandReducer from '../expandCollapse/expandCollapseSlice';
import smallLoadingReducer from '../smallLoading/smallLoadingSlice';
import logoutRequestedReducer from '../logoutRequested/logoutRequestedSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  tabs: tabsReducer,
  error: errorReducer,
  expand: expandReducer,
  success: successReducer,
  tickets: ticketsReducer,
  loading: loadingReducer,
  language: languageReducer,
  userData: userDataReducer,
  sideBarData: sideBarDataReducer,
  smallLoading: smallLoadingReducer,
  logoutRequested: logoutRequestedReducer,
});

export default rootReducer;
